export function safeClone(obj) {
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(obj);
    } catch (error) {
      // If structuredClone fails (e.g., with tracked objects), fall back to JSON methods
      return JSON.parse(JSON.stringify(obj));
    }
  }

  return JSON.parse(JSON.stringify(obj));
}
